import RequestError from './RequestError.js';

export default class ApiValidationError extends RequestError {
    constructor(method, url, xhr, message = `API request failed validation: ${method} ${url} [${xhr.status}]`) {
        super(method, url, xhr, message);
        this.errors = xhr.responseJSON.errors;
        this.warnings = xhr.responseJSON.warnings;
    }
}
